export const FEEDBACK_LINK_TEXT = 'Share feedback'
